import { OPEN_DRAWER } from "../constants";



export function openDrawerAction(drawer) {
  return {
    type: OPEN_DRAWER,
    payload: drawer,
  };
}
